import styled from 'styled-components';

const Container = styled.article`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  background-color: #fff;
  z-index: 2;
  padding: 16px 16px 0px 16px;
  overflow: auto;
  color: #161d1f;
  .divider {
    background: #84b1cc;
    margin: 6px 0;
  }
  .divider2 {
    background: #84b1cc;
    margin: 16px 0;
  }
  @media (min-width: 640px) {
    width: 397px;
  }
`;

const CloseButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  background-color: #fff;
  position: fixed;
  top: 0px;
  width: inherit;
  right: 0px;
  height: 52px;
  align-items: center;
  border-bottom: none;
  padding-right: 4px;
  .closeIcon {
    padding: 10px;
    border-radius: 4px;
    img {
      cursor: pointer;
      height: 24px;
    }
    &:hover {
      background-color: #fed4d6;
    }
    &:focus,
    &:active {
      background-color: #fdadb3;
    }
  }
  @media (min-width: 768px) {
    border-bottom: 1px solid #7a959f;
  }
`;

const Detail = styled.div`
  margin-top: 52px;
  .title {
    font-family: Lato;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    text-align: left;
    width: max-content;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .legend {
    margin-bottom: 32px;

    .content {
      .title {
        font-family: Lato;
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        text-align: left;
      }

      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        text-align: left;

        .item {
          display: flex;
          align-items: center;
          min-width: 128px;

          .icon {
            margin-right: 5px;
          }

          .text {
            margin-right: 5px;
            width: 79px;
          }

          .value {
            font-family: Lato;
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            text-align: left;
          }
        }
      }
    }
  }
`;

export { Container, CloseButton, Detail };
